<script setup>
</script>
<template>
  <div class="loader fixed inset-0 bg-white/50 z-10">
    <div class="sticky top-[250px]">
      <slot />
      <div class="spinner">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
      </div>
    </div>
  </div>
</template>
